import { Col, Row } from 'antd';
import React from 'react';
import SectionHeader from '../SectionHeader/SectionHeader';
import AuthorCard from './AuthorCard';

function AuthorGrid({
  sectionHeading,
  headerLink,
  headerDescription,
  data = [],
  responsive
}) {
  return (
    <section className={`authorgrid ${responsive ? 'responsive-view' : ''}`}>
      <div className="container">
        <SectionHeader
          heading={sectionHeading}
          headerLink={headerLink}
          headerDescription={headerDescription}
        />
        <Row
          gutter={[
            {
              xs: 8,
              sm: responsive ? 8 : 16,
              md: responsive ? 8 : 16,
              lg: responsive ? 8 : 16
            },
            {
              xs: 16,
              sm: 16,
              md: responsive ? 16 : 32,
              lg: responsive ? 16 : 32
            }
          ]}
        >
          {data?.map((item) => {
            return (
              <Col
                key={item?.id}
                xs={{ span: 12 }}
                md={{ span: responsive ? 12 : 8 }}
                lg={{ span: responsive ? 12 : 6 }}
                xxl={{ span: responsive ? 12 : 6 }}
              >
                <div className=" ">
                  <AuthorCard
                    href={item?.href}
                    speaker={item?.speaker}
                    videoCount={item?.videoCount}
                    image={item?.url}
                    blurHash={item.blurHash}
                  />
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </section>
  );
}
export default AuthorGrid;
